// extracted by mini-css-extract-plugin
module.exports = {"header":"Slide_header__gZAMU","container":"Slide_container__3J81O"};